"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YellowButton = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
require("./YellowButton.scss");
var Button_1 = require("./Button");
var YellowButton = function (props) { return (react_1.default.createElement(Button_1.Button, { type: props.type, disabled: props.disabled, className: classnames_1.default('button-yellow', props.className), isFullWidth: props.isFullWidth, onClick: props.onClick }, props.children)); };
exports.YellowButton = YellowButton;
